import { Currency } from '@kodiak-finance/sdk-core'
import { unsupportedSwapTokens } from 'constants/unsupportedSwapTokens'
import { useMemo } from 'react'

const unsupportedTokens = new Set(unsupportedSwapTokens.map((addr) => addr.toLowerCase()))

/**
 * Returns true if the input currency or output currency cannot be traded in the interface
 * @param currencyIn the input currency to check
 * @param currencyOut the output currency to check
 */
export function useIsSwapUnsupported(currencyIn?: Currency | null, currencyOut?: Currency | null): boolean {
  return useMemo(() => {
    const currencyInUnsupported = Boolean(
      currencyIn?.isToken && unsupportedTokens.has(currencyIn.address.toLowerCase())
    )
    const currencyOutUnsupported = Boolean(
      currencyOut?.isToken && unsupportedTokens.has(currencyOut.address.toLowerCase())
    )
    return currencyInUnsupported || currencyOutUnsupported
  }, [currencyIn, currencyOut])
}

export function isTokenUnsupported(tokenAddress: string | undefined): boolean {
  if (!tokenAddress) return false
  return unsupportedTokens.has(tokenAddress.toLowerCase())
}
